import React from "react";
//#region types
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";
import { EntityIdParams } from "models/propTypes/urlParamsTypes";
//#endregion
//#region components
import {
  PageLayouts,
  useMountedState,
  useNavigationHistory,
  useAPIRequestKeyRef,
  EntityCardLayout,
  Skeletons,
} from "components/common";
import { ErrorView } from "components/error";
import SalaryDraft from "./salaryDraft";
import { useParams } from "react-router-dom";
import { useSalaryDeviationsService } from "serviceHooks";
//#endregion
import cssExports from "theme/styles/main.module.scss";
import clsx from "clsx";
import { ServiceHelper } from "utils/helpers";

const SalaryDraftView: React.FC = () => {
  const salaryDeviationsService = useSalaryDeviationsService();
  const urlParams = useParams<EntityIdParams>();
  const id = Number.parseInt(urlParams.id ?? "0");

  const { getMounted } = useMountedState();
  const { goBack } = useNavigationHistory();

  const [notFound, setNotFound] = React.useState<boolean>();
  const [salaryDraft, setSalaryDraft] = React.useState<WintSuperkollAPIModel.SalaryDraft>();
  const [key, setKey] = React.useState(0);

  const { apiRequestKeyRef, updateKey } = useAPIRequestKeyRef();

  const loadSalaryDraft = (
    onSuccess?: (salaryDraft: WintSuperkollAPIModel.SalaryDraft) => void,
    onError?: () => void
  ) => {
    const currentKey = updateKey();

    ServiceHelper.withAPIRequestKey(salaryDeviationsService.getById(id), currentKey)
      .then((result) => {
        if (getMounted() && result.key === apiRequestKeyRef.current) {
          setNotFound(false);
          setSalaryDraft(result.data);
          setKey(key + 1);
        }

        onSuccess && onSuccess(result.data);
      })
      .catch(() => {
        if (salaryDraft) {
          setTimeout(() => {
            goBack();
          }, 1000);
          onError && onError();
        } else setNotFound(true);
      });
  };

  React.useEffect(() => {
    setSalaryDraft(undefined);
    loadSalaryDraft();
  }, [id]);

  return notFound ? (
    <ErrorView />
  ) : (
    <>
      <PageLayouts.EntityFullScreen
        entityKey={`salary-draft`}
        id={salaryDraft?.id ?? 0}
        className={clsx(cssExports.transparent, cssExports.cardNavigation)}
      >
        <EntityCardLayout hasInfoViewerInitially>
          {salaryDraft ? (
            <SalaryDraft
              key={key}
              salaryDraft={salaryDraft}
              reloadHandler={loadSalaryDraft}
              parentId={salaryDraft.id}
            />
          ) : (
            <Skeletons.EntityCardSkeleton />
          )}
        </EntityCardLayout>
      </PageLayouts.EntityFullScreen>
    </>
  );
};

export default SalaryDraftView;
